import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowRight } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export const KycReminderBanner = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  if (!isAuthenticated || !user || user.kyc_verified) return null;

  return (
    <div className="mx-2 sm:mx-4 mt-2 sm:mt-4" data-testid="kyc-reminder-banner">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-[#B8860B]/40 bg-gradient-to-r from-[#FFF8E7] to-[#F5E6C8] px-4 py-3 shadow-sm">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="w-9 h-9 rounded-full bg-[#B8860B]/15 border border-[#B8860B]/30 flex items-center justify-center shrink-0">
            <ShieldAlert className="w-5 h-5 text-[#996515]" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-[#00302B]">Complete Aadhaar KYC to start booking gold</p>
            <p className="text-xs text-[#6B5A2E] mt-0.5">
              Aadhaar verification is required before you can book, refund or redeem. It takes about a minute.
            </p>
          </div>
        </div>
        <button
          data-testid="kyc-reminder-verify-btn"
          onClick={() => navigate('/kyc-new')}
          className="self-start sm:self-auto inline-flex items-center gap-1.5 rounded-full bg-[#004D40] px-4 py-2 text-sm font-medium text-white hover:bg-[#00302B] transition-colors"
        >
          Verify now <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
